<script>
	//import MaskInput from "svelte-input-mask";
	import MaskInput from "svelte-input-mask/MaskInput.svelte";
	export let value = ""
	export let valuesrc = ""
	export let isvalid = false

	let mask = "0000-0000-0000-0000";

	// const handleChange2 = (ev) => {
	// 	//console.log(detail)
	//   if (ev.detail.inputState.maskedValue.indexOf("34") === 0 || ev.detail.inputState.maskedValue.indexOf("37") === 0) {
	//     	mask = "0000-000000-00000";
	//     	console.log("changed");
	//     	return;
	//   }
	//   mask = "0000-0000-0000-0000";
	// };

	const handleChange = e => {
		// console.log(e)
	  	value = e.detail.inputState.maskedValue;
	  	valuesrc = e.detail.inputState.unmaskedValue;
	  	isvalid = isValidCard(valuesrc)
	};

	function isValidCard(numero_tarjeta) {
		let cadena = ("0"+numero_tarjeta+'').substr(-16);
		let longitud = cadena.length;
		let cifra = null;
		let cifra_cad=null;
		let suma=0;
		for (let i=0; i < longitud; i+=2){
			cifra = parseInt(cadena.charAt(i))*2;
			if (cifra > 9){ 
				cifra_cad = cifra.toString();
				cifra = parseInt(cifra_cad.charAt(0)) + 
				parseInt(cifra_cad.charAt(1));
			}
			suma+=cifra;
		}
		for (let i=1; i < longitud; i+=2){
			suma += parseInt(cadena.charAt(i));
		}

		if ((suma % 10) == 0){ 
			return true
		} else {
			return false
		}
	}

</script>

<MaskInput {...$$props} alwaysShowMask maskChar="_" {mask} on:change={handleChange} />
